<template>
  <div
    class="page" :class="busy ? 'busy' : ''" >
    <slot></slot>
  </div>
</template>

<script>
  export default {
    computed: {
      busy () {
        return this.$store.state.busy
      },
    },
  }
</script>

<style lang="scss">
  .page {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
